import R from 'ramda';

import { getSurveys, postSurvey, postSubmitSurvey } from '_api/surveys';

import { setSurveys } from '_actions/surveys';


import { dispatchError } from '_utils/api';

export const attemptGetSurveys = () => dispatch =>
  getSurveys()
    .then(data => {
      const surveys = R.map(survey =>
        R.omit(['Id'], R.assoc('id', survey._id, survey)), data.surveys);

      dispatch(setSurveys(surveys.map(s => {
        let sections = new Set();

        for (const route of s.routes) {
          sections.add(route.title["section"])
        }

        s.meta = {
          length: s.routes.length,
          sections: sections
        }

        return s
      })));

      return data.surveys;
    })
    .catch(dispatchError(dispatch));

export const attemptSubmitSurvey = (info) => dispatch =>
  postSubmitSurvey(info)
    .then(data => {
      return data; //TODO: check in on this
    })
    .catch(dispatchError(dispatch));